/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { ChartParms } from "@src/app/model/sys/nav-item";
import { User } from "@src/app/model/user";
import { ApDetailPageComponent } from "@src/app/modules/txn/ap-detail-page/ap-detail-page.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const ApDetailPageNavRoute = new NavRoute('txn/purchaseDetail', ()=>ApDetailPageComponent, 'shopping_cart').setCharts([
    { type: 'bar', picklist: 'typeId' } as ChartParms,
    { type: 'bar', picklist: 'supplierId', number: 'txnValue', excludeZero: true } as ChartParms,
    { type: 'bar', picklist: 'bCodeId', number: 'txnValue', excludeZero: true } as ChartParms
]).setViews((u: User) => {
    return [
        {
            id: 'currentYear',
            name: 'Current Year',
            helpText: 'Purchase line items for the current financial year; change the year filter to view a different year',
            filterFields: {
                refNr: null,
                txnCycleId: u.currentTeam.currentPeriod?.cycleId,
            },
        }
    ]
});
